import { useEffect, useState } from 'react';
import { getRingPrefab } from './RingPrefabManager';


export function useRingPrefab(planetName) {
  const [ringObject, setRingObject] = useState(null);

  useEffect(() => {
    let isMounted = true;
    setRingObject(null); // Reset on planet change

    getRingPrefab(planetName).then((obj) => {
      if (isMounted && obj) setRingObject(obj);
    });

    return () => {
      isMounted = false;
    };
  }, [planetName]);

  return ringObject;
}
